<obg-glide *ngIf="banners?.length" [slideWidth]="slideWidth" [items]="banners" [options]="glideOptions">
	<article
		obg-common-banner-slide
		obgServerStyle
		*ngFor="let banner of banners; trackBy: trackByBanner; let index = index"
		[banner]="banner"
		[showTermsTitle]="showTermsTitle"
		(click)="onBannerClick({ index: index, key: banner.key })"
	></article>
</obg-glide>
